module.exports = __webpack_public_path__ + "img/airpurifier.a71cabf4.png";